import React from "react";
import { GiftCardListPage } from "../../Components/dashboard";

const MyGiftCardPage = () => {
  return <GiftCardListPage role="creator" />;
};

export default MyGiftCardPage;
